module.exports = __webpack_public_path__ + "static/media/avacado.e8ef9669.png";